import React from 'react';
import { motion } from 'framer-motion';
import { Palette, Layout, Smartphone, Globe, Megaphone, Lightbulb, ArrowUpRight } from 'lucide-react';
const services = [{
  icon: Palette,
  title: 'Brand Identity',
  description: 'Distinctive visual systems that set you apart.',
  id: '01'
}, {
  icon: Layout,
  title: 'UI/UX Design',
  description: 'Intuitive interfaces built for user needs.',
  id: '02'
}, {
  icon: Globe,
  title: 'Web Development',
  description: 'Robust, scalable, and performant websites.',
  id: '03'
}, {
  icon: Smartphone,
  title: 'Mobile Design',
  description: 'Seamless experiences across all devices.',
  id: '04'
}, {
  icon: Lightbulb,
  title: 'Strategy',
  description: 'Data-driven insights to guide your growth.',
  id: '05'
}, {
  icon: Megaphone,
  title: 'Marketing',
  description: 'Campaigns that convert and amplify reach.',
  id: '06'
}];
export function Services() {
  return <section id="services" className="bg-white border-b-2 border-black" data-id="element-190">
      <div className="container mx-auto px-0" data-id="element-191">
        <div className="grid grid-cols-1 lg:grid-cols-12" data-id="element-192">
          {/* Header */}
          <div className="lg:col-span-4 p-8 lg:p-12 border-b-2 lg:border-b-0 lg:border-r-2 border-black bg-swiss-gray" data-id="element-193">
            <h2 className="text-5xl md:text-6xl font-heading font-black text-black uppercase mb-6 leading-none" data-id="element-194">
              Our
              <br data-id="element-195" />
              Expertise
            </h2>
            <p className="text-lg font-medium text-black mb-8" data-id="element-196">
              We don't just make things look good. We make them work.
              Comprehensive solutions for modern businesses.
            </p>
            <div className="w-16 h-2 bg-swiss-red" data-id="element-197"></div>
          </div>

          {/* Grid */}
          <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2" data-id="element-198">
            {services.map((service, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`p-8 border-b-2 border-black ${index % 2 === 0 ? 'md:border-r-2' : ''} hover:bg-black hover:text-white transition-colors group cursor-pointer`} data-id="element-199">
                <div className="flex justify-between items-start mb-8" data-id="element-200">
                  <span className="font-heading font-black text-3xl text-transparent text-stroke-black group-hover:text-stroke-white opacity-50" data-id="element-201">
                    {service.id}
                  </span>
                  <ArrowUpRight className="opacity-0 group-hover:opacity-100 transition-opacity" size={24} data-id="element-202" />
                </div>

                <h3 className="text-2xl font-black uppercase mb-4" data-id="element-203">
                  {service.title}
                </h3>
                <p className="font-medium opacity-80" data-id="element-204">{service.description}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}